<script>
    import Timokatalogoi from "./comp/settings/Timokatalogoi.svelte";
    import Eidikotites from "./comp/settings/Eidikotites.svelte";
</script>

<div class="mx-auto max-w-7xl">
    <Timokatalogoi/>
    <Eidikotites/>
</div>